'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishMessage = exports.publishMessageFailed = exports.publishMessageSucceeded = exports.publishMessageStarted = undefined;

var _asyncActionTypes = require('../../pubsub/constants/asyncActionTypes');

var _reduxActions = require('redux-actions');

var _getClient = require('../../pubsub/selectors/getClient');

var _buildPublishFailedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildPublishFailedMessage');

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _addMessageToConversation = require('../../actions/ConversationsActions/addMessageToConversation');

var _updateMessageInConversation = require('../../actions/ConversationsActions/updateMessageInConversation');

var _buildMessageKey = require('conversations-schema/pubnub-message/operators/buildMessageKey');

var _initializePubSub = require('./initializePubSub');

var PUBLISH_MESSAGE = (0, _makeRequestActionTypes.makeRequestActionTypes)(_asyncActionTypes.PUBLISH_MESSAGE);

var publishMessageStarted = exports.publishMessageStarted = (0, _reduxActions.createAction)(PUBLISH_MESSAGE.STARTED);
var publishMessageSucceeded = exports.publishMessageSucceeded = (0, _reduxActions.createAction)(PUBLISH_MESSAGE.SUCCEEDED);
var publishMessageFailed = exports.publishMessageFailed = (0, _reduxActions.createAction)(PUBLISH_MESSAGE.FAILED);

var doPublishMessage = function doPublishMessage(_ref) {
  var channel = _ref.channel,
      message = _ref.message;
  return function (dispatch, getState) {
    dispatch(publishMessageStarted({ channel: channel, message: message }));

    dispatch((0, _addMessageToConversation.addMessageToConversation)({
      message: message,
      channel: channel
    }));

    var client = (0, _getClient.getClient)(getState());

    var publishData = {
      message: (0, _PubNubMessageSerializer.serialize)(message),
      channel: channel
    };

    var promise = client.publish(publishData).then(function (_ref2) {
      var json = _ref2.message,
          timetoken = _ref2.timetoken;

      var publishedMessage = (0, _PubNubMessageSerializer.deserialize)({ channel: channel, json: json, timetoken: timetoken });

      dispatch(publishMessageSucceeded({
        channel: channel,
        messageKey: (0, _buildMessageKey.buildMessageKey)(message),
        publishedMessage: publishedMessage
      }));
      dispatch((0, _updateMessageInConversation.updateMessageInConversation)({
        updated: publishedMessage,
        channel: channel,
        message: message
      }));
    }).catch(function (error) {
      var failed = (0, _buildPublishFailedMessage.buildPublishFailedMessage)(message);

      dispatch(publishMessageFailed({
        channel: channel,
        messageKey: (0, _buildMessageKey.buildMessageKey)(message),
        error: error
      }));
      dispatch((0, _updateMessageInConversation.updateMessageInConversation)({
        updated: failed,
        channel: channel,
        message: message
      }));
    });

    promise.done();
    return promise;
  };
};

var publishMessage = exports.publishMessage = function publishMessage(_ref3) {
  var channel = _ref3.channel,
      message = _ref3.message;
  return function (dispatch, getState) {
    return dispatch((0, _initializePubSub.initializePubSub)()).then(function () {
      return doPublishMessage({ channel: channel, message: message })(dispatch, getState);
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/publishMessage.js
// module id = 138
// module chunks = 2 3